import type { RequestProductsMetadata, TriggerName } from 'src/redux/products/types';

type ProductsQueryURLSyncIntent = {
  href: string;
  metadata?: RequestProductsMetadata;
  triggerName: TriggerName.RESET_ALL_FACETS_AND_SORT | TriggerName.RESET_FACET;
};

let pendingProductsQueryURLSyncIntent: ProductsQueryURLSyncIntent | null = null;

export const setPendingProductsQueryURLSyncIntent = (intent: ProductsQueryURLSyncIntent): void => {
  pendingProductsQueryURLSyncIntent = intent;
};

const normalizeHref = (href: string): string => {
  try {
    const url = new URL(href, 'https://www.notonthehighstreet.com');
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return href;
  }
};

export const consumePendingProductsQueryURLSyncIntent = (
  asPath: string,
): Omit<ProductsQueryURLSyncIntent, 'href'> | null => {
  if (!pendingProductsQueryURLSyncIntent) {
    return null;
  }

  const intent = pendingProductsQueryURLSyncIntent;
  pendingProductsQueryURLSyncIntent = null;

  if (normalizeHref(intent.href) !== normalizeHref(asPath)) {
    return null;
  }

  return {
    metadata: intent.metadata,
    triggerName: intent.triggerName,
  };
};
